var map = {
	"./Everpay-dark-logo_lghtzd.png": 217,
	"./Everpay-icon_ihn2fk(1).png": 218,
	"./Everpaylogo-261x67_jrwizm.png": 219,
	"./Img-01.jpg": 220,
	"./Img-02.jpg": 221,
	"./Img-03.jpg": 222,
	"./Img-05.jpg": 223,
	"./Img-07.jpg": 224,
	"./K.png": 225,
	"./POS-Payment_jsq3l2.jpg": 226,
	"./b.png": 227,
	"./blog-grid/author_img.png": 228,
	"./blog-grid/blog_list1.jpg": 229,
	"./blog-grid/blog_list2.jpg": 230,
	"./blog-grid/blog_list3.jpg": 231,
	"./blog-grid/blog_list4.jpg": 232,
	"./blog-grid/blog_single.png": 233,
	"./blog-grid/comment1.png": 234,
	"./blog-grid/comment2.png": 235,
	"./blog-grid/post_1.jpg": 236,
	"./blog-grid/post_2.jpg": 237,
	"./blog-grid/post_3.jpg": 238,
	"./blog-grid/post_4.jpg": 239,
	"./blog-grid/post_img_1.png": 240,
	"./blog-grid/post_img_2.png": 241,
	"./blog-grid/post_img_3.png": 242,
	"./br_logo.png": 243,
	"./breadcrumb/banner_bg.png": 244,
	"./breadcrumb/service.png": 245,
	"./breadcrumb/service_details.png": 246,
	"./breadcrumb/service_details_one.png": 247,
	"./cart1.jpg": 248,
	"./cart2.jpg": 249,
	"./cp-solutions/chargeback.png": 63,
	"./cp-solutions/norisk.png": 64,
	"./cp-solutions/privacy.png": 65,
	"./device-macbook-2_dbocag.png": 250,
	"./erp-home/action_img.png": 251,
	"./erp-home/background.png": 252,
	"./erp-home/banner_shap.png": 253,
	"./erp-home/cloud-computing.png": 254,
	"./erp-home/cloud_01.png": 255,
	"./erp-home/cloud_02.png": 256,
	"./erp-home/cloud_03.png": 257,
	"./erp-home/cloud_04.png": 258,
	"./erp-home/cloud_05.png": 259,
	"./erp-home/cloud_06.png": 260,
	"./erp-home/crm_img1.jpg": 261,
	"./erp-home/crm_img2.jpg": 262,
	"./erp-home/crm_img3.jpg": 263,
	"./erp-home/erp_dashboard.jpg": 264,
	"./erp-home/erp_icon1.png": 265,
	"./erp-home/erp_icon2.png": 266,
	"./erp-home/erp_icon3.png": 267,
	"./erp-home/erp_icon4.png": 268,
	"./erp-home/erp_icon5.png": 269,
	"./erp-home/erp_icon6.png": 270,
	"./erp-home/growth.png": 271,
	"./erp-home/img/01.png": 272,
	"./erp-home/img/02.png": 273,
	"./erp-home/img/03.png": 274,
	"./erp-home/img/04.png": 275,
	"./erp-home/img/05.png": 276,
	"./erp-home/img/06.png": 277,
	"./erp-home/img/07.png": 278,
	"./erp-home/img/08.png": 279,
	"./erp-home/img/09.png": 280,
	"./erp-home/img/10.png": 281,
	"./erp-home/img/11.png": 282,
	"./erp-home/img/12.png": 283,
	"./erp-home/img/13.png": 284,
	"./erp-home/img/14.png": 285,
	"./erp-home/img/15.png": 286,
	"./erp-home/img/16.png": 287,
	"./erp-home/img/17.png": 288,
	"./erp-home/img/18.png": 289,
	"./erp-home/img/19.png": 290,
	"./erp-home/img/20.png": 291,
	"./erp-home/quote.png": 292,
	"./erp-home/rocket.png": 293,
	"./erp-home/settings1.png": 294,
	"./erp-home/shape.png": 295,
	"./erp-home/testimonial_img.jpg": 296,
	"./erp-home/testimonial_img2.jpg": 297,
	"./error_bg.png": 298,
	"./favicon.png": 299,
	"./frist_step_mpkory.jpg": 300,
	"./home-chat/Messages.jpg": 301,
	"./home-chat/Messages.png": 302,
	"./home-chat/book.png": 303,
	"./home-chat/box.png": 304,
	"./home-chat/chat.png": 305,
	"./home-chat/chat_01.png": 306,
	"./home-chat/chat_02.png": 307,
	"./home-chat/chat_icon.png": 308,
	"./home-chat/cloud.png": 309,
	"./home-chat/dashboard.png": 310,
	"./home-chat/dot.png": 311,
	"./home-chat/get_started_bg.png": 312,
	"./home-chat/john.png": 313,
	"./home-chat/left_leaf.png": 314,
	"./home-chat/live_chat.png": 315,
	"./home-chat/mobile.png": 316,
	"./home-chat/panguin_img_one.png": 317,
	"./home-chat/panguin_img_three.png": 318,
	"./home-chat/panguin_img_two.png": 319,
	"./home-chat/pluse.png": 320,
	"./home-chat/richard.png": 321,
	"./home-chat/right_leaf.png": 322,
	"./home-chat/skyp_1.png": 323,
	"./home-chat/skyp_2.png": 324,
	"./home-chat/support_dashboard.jpg": 325,
	"./home-chat/triangle.png": 326,
	"./home-chat/video_icon.png": 327,
	"./home-event/about.jpg": 328,
	"./home-event/banner_bg.jpg": 329,
	"./home-event/chat.png": 330,
	"./home-event/conference.jpg": 331,
	"./home-event/digital.jpg": 332,
	"./home-event/dot.png": 333,
	"./home-event/image_01.jpg": 334,
	"./home-event/image_02.jpg": 335,
	"./home-event/image_03.jpg": 336,
	"./home-event/image_04.jpg": 337,
	"./home-event/image_05.jpg": 338,
	"./home-event/image_06.jpg": 339,
	"./home-event/instragram1.jpg": 340,
	"./home-event/instragram2.jpg": 341,
	"./home-event/instragram3.jpg": 342,
	"./home-event/instragram4.jpg": 343,
	"./home-event/instragram5.jpg": 344,
	"./home-event/instragram6.jpg": 345,
	"./home-event/leader.png": 346,
	"./home-event/logo_09.jpg": 347,
	"./home-event/logo_10.jpg": 348,
	"./home-event/logo_11.jpg": 349,
	"./home-event/logo_12.jpg": 350,
	"./home-event/marker.png": 351,
	"./home-event/marketing.jpg": 352,
	"./home-event/meetup.png": 353,
	"./home-event/price_shap.png": 354,
	"./home-event/promo.jpg": 355,
	"./home-event/team1.jpg": 356,
	"./home-event/team2.jpg": 357,
	"./home-event/team3.jpg": 358,
	"./home-event/timer.png": 359,
	"./home-security/about_img_1.jpg": 66,
	"./home-security/about_img_2.jpg": 67,
	"./home-security/apple_icon.png": 68,
	"./home-security/banner.png": 69,
	"./home-security/face-face-payments.jpg": 70,
	"./home-security/leaf_clients1.png": 71,
	"./home-security/leaf_clients2.png": 72,
	"./home-security/mackbook.png": 73,
	"./home-security/padlock.png": 74,
	"./home-security/paying-for-order.jpg": 75,
	"./home-security/real-estate.png": 76,
	"./home-security/rocket.png": 77,
	"./home-security/security_1.png": 78,
	"./home-security/security_2.png": 79,
	"./home-security/security_3.png": 80,
	"./home-security/security_4.png": 81,
	"./home-security/shap.png": 82,
	"./home-security/sheld_bg.png": 83,
	"./home-security/shield.png": 84,
	"./home-security/windows_icon.png": 85,
	"./home-software/analytices1.png": 360,
	"./home-software/analytices2.png": 361,
	"./home-software/analytices3.png": 362,
	"./home-software/analytices4.png": 363,
	"./home-software/analytices5.jpg": 364,
	"./home-software/analytices6.jpg": 365,
	"./home-software/analytices7.jpg": 366,
	"./home-software/analytices8.jpg": 367,
	"./home-software/case.png": 368,
	"./home-software/down_bg.png": 369,
	"./home-software/elements_five.png": 370,
	"./home-software/elements_four.png": 371,
	"./home-software/elements_one.png": 372,
	"./home-software/elements_six.png": 373,
	"./home-software/elements_three.png": 374,
	"./home-software/elements_two.png": 375,
	"./home-software/line_02.png": 376,
	"./home-software/logo_01.png": 377,
	"./home-software/logo_02.png": 378,
	"./home-software/logo_03.png": 379,
	"./home-software/logo_04.png": 380,
	"./home-software/logo_05.png": 381,
	"./home-software/logo_06.png": 382,
	"./home-software/logo_07.png": 383,
	"./home-software/logo_08.png": 384,
	"./home-software/logo_09.png": 385,
	"./home-software/logo_10.png": 386,
	"./home-software/logo_11.png": 387,
	"./home-software/logo_12.png": 388,
	"./home-software/mackbook.png": 389,
	"./home-software/pie.png": 390,
	"./home-software/setup_img1.png": 391,
	"./home-software/setup_img2.png": 392,
	"./home-software/setup_img3.png": 393,
	"./home-software/shap_3.png": 394,
	"./home-software/shap_one.png": 395,
	"./home-software/shap_two.png": 396,
	"./home-tracking/activity_icon.png": 397,
	"./home-tracking/aliexpress.png": 398,
	"./home-tracking/amazon.png": 399,
	"./home-tracking/analyze_icon.png": 400,
	"./home-tracking/apple.png": 401,
	"./home-tracking/computer_tracking_img.jpg": 402,
	"./home-tracking/crismas.png": 403,
	"./home-tracking/cta.png": 404,
	"./home-tracking/cta_pattern_bg.jpg": 405,
	"./home-tracking/google.png": 406,
	"./home-tracking/left-dot.png": 407,
	"./home-tracking/month.png": 408,
	"./home-tracking/right-dot.png": 409,
	"./home-tracking/tesla.png": 410,
	"./home-tracking/time_icon.png": 411,
	"./home-tracking/tracking_banner_img.png": 412,
	"./home-tracking/watch_1.png": 413,
	"./home-tracking/windows.png": 414,
	"./home2/action_bg.png": 415,
	"./home2/file.png": 416,
	"./home2/inbox.png": 86,
	"./home2/report.png": 87,
	"./home2/undraw.png": 38,
	"./home3/action_image.png": 417,
	"./home3/dimond.png": 418,
	"./home3/logo_01.png": 419,
	"./home3/logo_02.png": 420,
	"./home3/logo_03.png": 421,
	"./home3/logo_04.png": 422,
	"./home3/logo_05.png": 423,
	"./home3/p_feature1.png": 424,
	"./home3/prototype_banner_img.png": 425,
	"./home3/prototype_banner_img2.png": 426,
	"./home3/psd.png": 427,
	"./home3/saas.png": 428,
	"./home3/tab.png": 429,
	"./home4/action_shap.png": 88,
	"./home4/author_img.png": 89,
	"./home4/banner_bg.png": 90,
	"./home4/banner_img.png": 91,
	"./home4/barrel_bar.jpg": 92,
	"./home4/big_resto.jpg": 93,
	"./home4/clover_station.jpg": 94,
	"./home4/divider.png": 95,
	"./home4/dot.png": 96,
	"./home4/face-face-payments.jpg": 97,
	"./home4/icon01.png": 98,
	"./home4/icon02.png": 99,
	"./home4/icon3.png": 100,
	"./home4/icon_04.png": 101,
	"./home4/icon_05.png": 102,
	"./home4/icon_shape1.png": 103,
	"./home4/icon_shape2.png": 104,
	"./home4/icon_shape3.png": 105,
	"./home4/icon_shape4.png": 106,
	"./home4/new_resto.jpg": 107,
	"./home4/paying-coffee.jpg": 108,
	"./home4/paying-for-order.jpg": 109,
	"./home4/preheader.jpg": 110,
	"./home4/process_1.png": 111,
	"./home4/process_2.png": 112,
	"./home4/process_3.png": 113,
	"./home4/process_4.png": 114,
	"./home4/process_5.png": 115,
	"./home4/shape.png": 116,
	"./home4/shop_clerk.jpg": 117,
	"./home4/showcase.jpg": 118,
	"./home4/small_btbwe3.jpg": 119,
	"./home4/speed_shopper.jpg": 120,
	"./home4/team1.jpg": 121,
	"./home4/team2.jpg": 122,
	"./home4/work1.png": 123,
	"./home4/work2.png": 124,
	"./home4/work3.png": 125,
	"./home5/01.jpg": 430,
	"./home5/02.jpg": 431,
	"./home5/03.jpg": 432,
	"./home5/banner_img.png": 433,
	"./home5/design1.png": 126,
	"./home5/design2.png": 127,
	"./home5/featured_bg_shape.png": 434,
	"./home5/featured_img1.png": 435,
	"./home5/icon1.png": 436,
	"./home5/icon2.png": 437,
	"./home5/icon3.png": 438,
	"./home5/icon_shape.png": 439,
	"./home5/php.jpg": 440,
	"./home5/shap_tecture.png": 441,
	"./home6/dashboard.jpg": 442,
	"./home6/featured_img_one.jpg": 443,
	"./home6/featured_img_two.jpg": 444,
	"./home6/feedback_img_one.png": 445,
	"./home6/feedback_img_three.png": 446,
	"./home6/feedback_img_two.png": 447,
	"./home6/logo_01.png": 448,
	"./home6/logo_02.png": 449,
	"./home6/logo_03.png": 450,
	"./home6/logo_04.png": 451,
	"./home6/logo_05.png": 452,
	"./home6/shape-1.png": 453,
	"./home6/shape2.png": 454,
	"./home6/trust_img.png": 455,
	"./home6/trust_img2.png": 456,
	"./home7/01.png": 457,
	"./home7/02.png": 458,
	"./home7/03.png": 459,
	"./home7/app.png": 460,
	"./home7/banner.png": 461,
	"./home7/google_icon.png": 462,
	"./home7/iPhoneX2.png": 463,
	"./home7/iPhonex.png": 464,
	"./home7/screenshot1.png": 465,
	"./home7/screenshot2.png": 466,
	"./home7/screenshot3.png": 467,
	"./home7/screenshot4.png": 468,
	"./home7/screenshot5.png": 469,
	"./home7/team_01.jpg": 470,
	"./home7/team_02.jpg": 471,
	"./home7/team_03.jpg": 472,
	"./home7/team_04.jpg": 473,
	"./home7/testimonial_author_img.png": 474,
	"./home7/text_one.png": 475,
	"./home7/text_three.png": 476,
	"./home7/text_two.png": 477,
	"./home8/banner_img.png": 478,
	"./home8/dot.png": 479,
	"./home8/fact.png": 480,
	"./home8/service_item_03.png": 481,
	"./home9/featured_img.png": 482,
	"./home9/featured_img_two.png": 483,
	"./home9/flag.png": 484,
	"./home9/footer.png": 485,
	"./home9/icon1.png": 486,
	"./home9/icon2.png": 487,
	"./home9/icon3.png": 488,
	"./home9/icon4.png": 489,
	"./home9/icon5.png": 490,
	"./home9/icon6.png": 491,
	"./home9/icon7.png": 492,
	"./home9/icon8.png": 493,
	"./home9/icon_shape.png": 494,
	"./home9/icon_shape_two.png": 495,
	"./home9/logo1.png": 496,
	"./home9/logo2.png": 497,
	"./home9/logo3.png": 498,
	"./home9/logo4.png": 499,
	"./home9/logo5.png": 500,
	"./home9/logo6.png": 501,
	"./home9/logo7.png": 502,
	"./home9/logo8.png": 503,
	"./home9/mac.png": 60,
	"./home9/map.png": 504,
	"./home9/shape-footer.png": 505,
	"./home9/shape.png": 506,
	"./home9/shape_two.png": 507,
	"./home9/testimonial_img.png": 508,
	"./home9/testimonial_img2.png": 509,
	"./home9/triangle_bottom.png": 510,
	"./home9/triangle_top.png": 511,
	"./hosting/action_img.png": 512,
	"./hosting/business1.png": 513,
	"./hosting/business2.png": 514,
	"./hosting/h_blog1.jpg": 515,
	"./hosting/h_blog2.jpg": 516,
	"./hosting/hosting-image.png": 517,
	"./hosting/hosting_action_bg.png": 128,
	"./hosting/icon1.png": 518,
	"./hosting/icon10.png": 519,
	"./hosting/icon2.png": 520,
	"./hosting/icon3.png": 521,
	"./hosting/icon4.png": 522,
	"./hosting/icon5.png": 523,
	"./hosting/icon6.png": 524,
	"./hosting/icon7.png": 525,
	"./hosting/icon8.png": 526,
	"./hosting/icon9.png": 527,
	"./hosting/line_01.png": 528,
	"./hosting/line_02.png": 529,
	"./hosting/line_03.png": 530,
	"./hosting/line_04.png": 531,
	"./hosting/line_05.png": 532,
	"./hosting/line_06.png": 533,
	"./hosting/line_07.png": 534,
	"./hosting/line_08.png": 535,
	"./hosting/map.png": 536,
	"./hosting/region_map.png": 537,
	"./industries/enterprise.png": 129,
	"./industries/not-for-profit.png": 130,
	"./industries/professional-practice.png": 131,
	"./industries/restaurant.png": 132,
	"./industries/retail.png": 133,
	"./industries/trade.png": 134,
	"./login_img.png": 538,
	"./login_img2.png": 539,
	"./logo-121.png": 540,
	"./logo-3-2x.png": 541,
	"./logo-full.png": 542,
	"./logo-old-2.png": 543,
	"./logo-old-2x-2.png": 544,
	"./logo-old.png": 545,
	"./logo-old2x.png": 546,
	"./logo-sticky-2x.png": 547,
	"./logo-sticky.png": 548,
	"./logo-sticky2.png": 549,
	"./logo-sticky3.png": 550,
	"./logo-sticky4.png": 551,
	"./logo.png": 552,
	"./logo1-full.png": 553,
	"./logo1.png": 554,
	"./logo2.png": 555,
	"./logo2x-2.png": 556,
	"./logo2x.png": 557,
	"./logo3.png": 558,
	"./logo4.png": 559,
	"./logo7.png": 560,
	"./logo8.png": 561,
	"./mega-menu-img/Prototyping_Tool.jpg": 562,
	"./mega-menu-img/analytices.jpg": 563,
	"./mega-menu-img/coming_img.jpg": 564,
	"./mega-menu-img/erp.jpg": 565,
	"./mega-menu-img/home-animation.jpg": 566,
	"./mega-menu-img/home-chat.jpg": 567,
	"./mega-menu-img/home-event.jpg": 568,
	"./mega-menu-img/home-security.jpg": 569,
	"./mega-menu-img/home-track.jpg": 570,
	"./mega-menu-img/home1.jpg": 571,
	"./mega-menu-img/home10.jpg": 572,
	"./mega-menu-img/home11.jpg": 573,
	"./mega-menu-img/home12.jpg": 574,
	"./mega-menu-img/home13.jpg": 575,
	"./mega-menu-img/home14.jpg": 576,
	"./mega-menu-img/home15.jpg": 577,
	"./mega-menu-img/home16.jpg": 578,
	"./mega-menu-img/home17.jpg": 579,
	"./mega-menu-img/home2.jpg": 580,
	"./mega-menu-img/home3.jpg": 581,
	"./mega-menu-img/home4.jpg": 582,
	"./mega-menu-img/home5.jpg": 583,
	"./mega-menu-img/home6.jpg": 584,
	"./mega-menu-img/home7.jpg": 585,
	"./mega-menu-img/home8.jpg": 586,
	"./mega-menu-img/home9.jpg": 587,
	"./mega-menu-img/hosting.jpg": 588,
	"./mega-menu-img/icon/app-d.png": 589,
	"./mega-menu-img/icon/blup.png": 590,
	"./mega-menu-img/pos.jpg": 591,
	"./mega-menu-img/saas2-slider.png": 592,
	"./mega-menu-img/support.jpg": 593,
	"./men.png": 594,
	"./more-ways-to-pay_mbgpb7.png": 595,
	"./new-home/back_bg.png": 596,
	"./new-home/banner.png": 597,
	"./new-home/briteverify.png": 598,
	"./new-home/campfire.png": 599,
	"./new-home/email.png": 600,
	"./new-home/kissmetrics.png": 601,
	"./new-home/metorik.png": 602,
	"./new-home/nicereply-1.png": 603,
	"./new-home/p-1.png": 135,
	"./new-home/p-2.png": 136,
	"./new-home/p-3.png": 137,
	"./new-home/tab.png": 604,
	"./new-home/tab_2.png": 605,
	"./new-home/tab_3.png": 606,
	"./new-home/ticket-support.png": 607,
	"./new-home/tree-left.png": 608,
	"./new-home/tree-right.png": 609,
	"./new-home/tree.png": 610,
	"./new-home/update.png": 611,
	"./new-home/webhooks.png": 612,
	"./new-home/wedsite.png": 613,
	"./new/01.png": 614,
	"./new/0111.png": 615,
	"./new/02.png": 616,
	"./new/0222.png": 617,
	"./new/03.png": 618,
	"./new/04.png": 619,
	"./new/05.png": 620,
	"./new/06.png": 621,
	"./new/app_screen.png": 622,
	"./new/blog/blog_grid_1.jpg": 623,
	"./new/blog/blog_grid_2.jpg": 624,
	"./new/blog/blog_grid_3.jpg": 625,
	"./new/blog/blog_grid_4.jpg": 626,
	"./new/blog/blog_grid_5.jpg": 627,
	"./new/blog/blog_grid_6.jpg": 628,
	"./new/blog/blog_grid_7.jpg": 629,
	"./new/blog/blog_grid_8.jpg": 630,
	"./new/case/case_01.jpg": 631,
	"./new/case/case_02.jpg": 632,
	"./new/case/case_03.jpg": 633,
	"./new/case/case_04.jpg": 634,
	"./new/case/case_05.jpg": 635,
	"./new/case/case_06.jpg": 636,
	"./new/case/case_07.jpg": 637,
	"./new/case/case_08.jpg": 638,
	"./new/case/case_09.jpg": 639,
	"./new/case/case_10.jpg": 640,
	"./new/case/case_11.jpg": 641,
	"./new/case/case_12.jpg": 642,
	"./new/case/case_details_01.jpg": 643,
	"./new/case/case_details_02.jpg": 644,
	"./new/case/case_details_03.jpg": 645,
	"./new/case/parallax.png": 646,
	"./new/coming_soon_bg.png": 647,
	"./new/company.jpg": 648,
	"./new/cup.png": 649,
	"./new/digital_img.png": 650,
	"./new/error.png": 651,
	"./new/features_01.png": 652,
	"./new/feedback_shap.png": 653,
	"./new/home-split/contact.png": 654,
	"./new/iPhoneX.png": 655,
	"./new/icon.png": 656,
	"./new/icon/icon1.png": 657,
	"./new/icon/icon2.png": 658,
	"./new/icon2.png": 659,
	"./new/icon3.png": 660,
	"./new/intregration_1.png": 661,
	"./new/intregration_2.png": 662,
	"./new/intregration_3.png": 663,
	"./new/intregration_4.png": 664,
	"./new/laptop.png": 665,
	"./new/laptop_two.png": 666,
	"./new/leaf.png": 667,
	"./new/line_01.png": 668,
	"./new/line_02.png": 669,
	"./new/line_03.png": 670,
	"./new/logo_01.png": 671,
	"./new/logo_02.png": 672,
	"./new/logo_03.png": 673,
	"./new/logo_04.png": 674,
	"./new/logo_05.png": 675,
	"./new/member_01.jpg": 676,
	"./new/new_shape.png": 677,
	"./new/phone.png": 678,
	"./new/price_bg.png": 679,
	"./new/shape_bg.png": 680,
	"./new/solution_01.jpg": 681,
	"./new/solution_02.jpg": 682,
	"./new/startup_banner_bg.png": 683,
	"./new/startup_banner_img.png": 684,
	"./new/startup_shap.png": 685,
	"./new/tab_shape_bg.png": 686,
	"./new/testimonial_bg.png": 687,
	"./new/testimonial_bg_shap.png": 688,
	"./new/testimonial_bg_two.png": 689,
	"./new/video_bg.jpg": 690,
	"./new/video_img_01.png": 691,
	"./new/video_img_02.jpg": 692,
	"./new/web_image.jpg": 693,
	"./new_logo.png": 694,
	"./payment-terminal_ffzrvq.jpg": 695,
	"./payment/cp/cp-step-1.png": 696,
	"./payment/cp/cp-step-2.png": 697,
	"./payment/cp/cp-step-3.png": 698,
	"./portfolio-details/pr_details1.jpg": 699,
	"./portfolio-details/pr_details2.jpg": 700,
	"./portfolio-details/pr_details3.jpg": 701,
	"./portfolio-details/pr_details4.jpg": 702,
	"./portfolio/2-columns/grid1.jpg": 703,
	"./portfolio/2-columns/grid2.jpg": 704,
	"./portfolio/2-columns/grid3.jpg": 705,
	"./portfolio/2-columns/grid4.jpg": 706,
	"./portfolio/2-columns/grid5.jpg": 707,
	"./portfolio/2-columns/grid6.jpg": 708,
	"./portfolio/2-columns/grid7.jpg": 709,
	"./portfolio/2-columns/grid8.jpg": 710,
	"./portfolio/3-columns/3_col_1.jpg": 711,
	"./portfolio/3-columns/3_col_10.jpg": 712,
	"./portfolio/3-columns/3_col_11.jpg": 713,
	"./portfolio/3-columns/3_col_12.jpg": 714,
	"./portfolio/3-columns/3_col_2.jpg": 715,
	"./portfolio/3-columns/3_col_3.jpg": 716,
	"./portfolio/3-columns/3_col_4.jpg": 717,
	"./portfolio/3-columns/3_col_5.jpg": 718,
	"./portfolio/3-columns/3_col_6.jpg": 719,
	"./portfolio/3-columns/3_col_7.jpg": 720,
	"./portfolio/3-columns/3_col_8.jpg": 721,
	"./portfolio/3-columns/3_col_9.jpg": 722,
	"./portfolio/full-width/full_1.jpg": 723,
	"./portfolio/full-width/full_10.jpg": 724,
	"./portfolio/full-width/full_11.jpg": 725,
	"./portfolio/full-width/full_12.jpg": 726,
	"./portfolio/full-width/full_2.jpg": 727,
	"./portfolio/full-width/full_3.jpg": 728,
	"./portfolio/full-width/full_4.jpg": 729,
	"./portfolio/full-width/full_5.jpg": 730,
	"./portfolio/full-width/full_6.jpg": 731,
	"./portfolio/full-width/full_7.jpg": 732,
	"./portfolio/full-width/full_8.jpg": 733,
	"./portfolio/full-width/full_9.jpg": 734,
	"./pos/High-end-all-in-one-dual-screen.png": 735,
	"./pos/b_dashboard.png": 736,
	"./pos/cash-register.png": 737,
	"./pos/chat.png": 738,
	"./pos/credit-card.png": 739,
	"./pos/delivery-truck.png": 740,
	"./pos/ezgif-1-997e5035cba4.png": 741,
	"./pos/fotter_shap.png": 742,
	"./pos/icon1.png": 743,
	"./pos/icon2.png": 744,
	"./pos/icon3.png": 745,
	"./pos/item1.png": 746,
	"./pos/item2.png": 747,
	"./pos/item3.png": 748,
	"./pos/laptop.png": 749,
	"./pos/leaf-left.png": 750,
	"./pos/leaf-right.png": 751,
	"./pos/mailbox.png": 752,
	"./pos/man.png": 753,
	"./pos/pattern_01.png": 754,
	"./pos/pattern_02.png": 755,
	"./pos/people.png": 756,
	"./pos/pos.png": 757,
	"./pos/pos_about_img.png": 758,
	"./pos/pos_blog_1.png": 759,
	"./pos/pos_blog_2.png": 760,
	"./pos/pos_blog_3.png": 761,
	"./pos/pos_slideshow1.jpg": 762,
	"./pos/pos_slideshow2.jpg": 763,
	"./pos/pos_slideshow3.jpg": 764,
	"./pos/shape.png": 765,
	"./pos/shape_bg.png": 766,
	"./pos/statistics.png": 767,
	"./pos/tab_pattern.png": 768,
	"./pos/wave_two.png": 769,
	"./pos/women.png": 770,
	"./price/one.png": 771,
	"./price/three.png": 772,
	"./price/two.png": 773,
	"./process/ASAN-logo-icon.png": 774,
	"./process/Avast_Antivirus.png": 775,
	"./process/UTorrent_(logo).png": 776,
	"./process/btFMmsoh.png": 777,
	"./process/logo-slack.png": 778,
	"./process/png-logo-design.png": 779,
	"./qoute.png": 780,
	"./retail-fp_phsag5.jpg": 781,
	"./saas/map.png": 782,
	"./seo/bike.png": 783,
	"./seo/car.png": 784,
	"./seo/cloud.png": 785,
	"./seo/cloud_bg.png": 786,
	"./seo/features_img.png": 787,
	"./seo/features_img_two.png": 788,
	"./seo/footer_bg.png": 789,
	"./seo/icon1.png": 138,
	"./seo/icon2.png": 139,
	"./seo/icon3.png": 790,
	"./seo/icon4.png": 791,
	"./seo/icon5.png": 140,
	"./seo/image.png": 792,
	"./seo/logo_01.png": 793,
	"./seo/logo_02.png": 794,
	"./seo/logo_03.png": 795,
	"./seo/logo_04.png": 796,
	"./seo/logo_05.png": 797,
	"./seo/logo_06.png": 798,
	"./seo/logo_07.png": 799,
	"./seo/logo_08.png": 800,
	"./seo/logo_09.png": 801,
	"./seo/shap.png": 802,
	"./seo/studies_img_one.jpg": 803,
	"./seo/studies_img_three.jpg": 804,
	"./seo/studies_img_two.jpg": 805,
	"./seo/triangle_one.png": 806,
	"./seo/triangle_three.png": 807,
	"./seo/triangle_two.png": 808,
	"./services/business-financing.png": 141,
	"./services/everpay-field-service.png": 142,
	"./services/gift-card-offerings.png": 143,
	"./services/loyalty.png": 39,
	"./support_female_hjszor.jpg": 809,
	"./svg.svg": 810,
	"./teams/team_01.jpg": 144,
	"./teams/team_02.jpg": 145,
	"./teams/team_03.jpg": 146,
	"./teams/team_04.jpg": 147,
	"./teams/team_10.jpg": 148,
	"./teams/team_12.jpg": 149,
	"./teams/team_5.jpg": 150,
	"./teams/team_6.jpg": 151,
	"./teams/team_7.jpg": 152,
	"./teams/team_8.jpg": 153,
	"./teams/team_9.jpg": 154,
	"./up_mekdzw.png": 811,
	"./verifi_acct_nbbzpr.jpg": 812,
	"./versipayments_zhnzif.jpg": 813,
	"./we-do-it_snkbp0.jpg": 814,
	"./why-us_hk0luy.jpg": 815
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62;